import _ from 'lodash'
function clearAddObject(vm, name) {
    let temp
    
    let clearAllIn = () => {
        vm[name] = _.cloneDeep(temp)
    }
    vm.clearAll = clearAllIn
    // vm[name].clearAll = clearAllIn
    // 解耦不建议放对象里
    temp = _.cloneDeep(vm[name])
}

export default { clearAddObject }


//////////////////
// WEBPACK FOOTER
// ./common/jackUtils.js
// module id = null
// module chunks = 